const specific_config = process.env.ENV === 'prod' ? require('./config.prod') : require('./config.dev');

export const environment = specific_config.ENVIRONMENT;
export const projectId = 'c679f6063761066df4de699e48a8459b';
export const proxyContractAddress = specific_config.PROXY_CONTRACT_ADDRESS;
export const multiversxUrlApi = specific_config.MULTIVERSX_API_URL;
export const multiversxExplorerUrl = specific_config.MULTIVERSX_EXPLORER_URL;
export const displayedCurrencyCode = specific_config.DISPLAYED_CURRENCY_CODE;
export const tokenIdentifier = specific_config.TOKEN_IDENTIFIER;
export const apiBaseUrl = specific_config.TADA_API;
export const tokenDecimal = 18;
export const gasLimit = 60000000;
export const useAprGuaranteedValues = true;
export const aprGuaranteedDisclaimerVisibility = true;
export const poolInformation = [
    {
        title: 'Tada Staking Pool - 1 Month',
        description: 'Lock in your tada tokens for one month and receive your rewards every day',
        unstakeDuration: 30,
        guaranteedApr: 1.5,
    },
    {
        title: 'Tada Staking Pool - 3 Months',
        description: 'Lock in your tada tokens for three months and receive your rewards every day',
        unstakeDuration: 90,
        guaranteedApr: 3,
    },
    {
        title: 'Tada Staking Pool - 6 Months',
        description: 'Lock in your tada tokens for six months and receive your rewards every day',
        unstakeDuration: 180,
        guaranteedApr: 6,
    },
    {
        title: 'Tada Staking Pool - 12 Months',
        description: 'Lock in your tada tokens for twelve months and receive your rewards every day',
        unstakeDuration: 360,
        guaranteedApr: 12,
    },
];
